import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Standard container class with responsive padding
 * This provides consistent padding across all major section components
 * 
 * Breakpoints:
 * Default: px-4 (16px)
 * sm: px-6 (24px) - screens above 640px
 * md: px-8 (32px) - screens above 768px
 * lg: px-16 (64px) - screens above 1024px
 * xl: px-24 (96px) - screens above 1280px
 */
export const containerClasses = "container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24"
